import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  selectPlate(event) {
    const inputGroup = event.currentTarget.closest(".input-group")
    inputGroup.classList.add("selected")
    this.updateVinRequiredState()
  }

  selectVin(event) {
    const inputGroup = event.currentTarget.closest(".input-group")
    inputGroup.classList.remove("selected")
    this.updateVinRequiredState()
  }

  updateVinRequiredState() {
    const form = this.element.closest("form")
    if (!form) return
    const hasLicensePlateMode = form.querySelector(".input-group.selected")
    form.querySelectorAll("input.vin").forEach((input) => {
      if (hasLicensePlateMode) {
        input.removeAttribute("required")
      } else {
        input.setAttribute("required", "required")
      }
    })
  }
}
